import React from 'react'
import { connect } from 'react-redux'

import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'
import FontAwesome from 'react-fontawesome'
import LinearProgress from 'material-ui/LinearProgress'
import Paper from 'material-ui/Paper'

const styles = {
  container: {
    marginBottom: 15,
    padding: 5,
  },
  lvl: {
    padding: 5,
    textAlign: 'left'
  },
  credits: {
    padding: 5,
    fontSize: '28px',
  },
  progress: {
    height: '8px',
    marginBottom: '10px'
  },
  experience: {
    color: '#a6a6a6',
    fontSize: '16px',
    marginLeft: '10px'
  },
}

class LvlExpCredits extends React.Component {

  render() {
    const { level, credits, relative_next_level_experience,
      relative_current_experience, experience } = this.props
    return (
      <Paper zDepth={1} style={styles.container} >
        <Row>
          <Col xs="12" md="6">
            <div
              style={styles.lvl}
              className="mui--text-headline"
            >
              Nivel {level} <span style={styles.experience}>EXP: {experience}</span>
            </div>
            <LinearProgress
              color="#f79410"
              mode="determinate"
              style={styles.progress}
              max={relative_next_level_experience}
              value={relative_current_experience}
            />
          </Col>
          <Col xs="12" md="6" >
            <div
              style={styles.credits}
              className="mui--text-headline mui--text-center"
            >
              <FontAwesome name="diamond" />
              {`   ${(credits || 0).toLocaleString()}`}
            </div>
          </Col>
        </Row>
      </Paper>
    )
  }
}

LvlExpCredits.propTypes = {
  level: React.PropTypes.number,
  credits: React.PropTypes.number,
  relative_next_level_experience: React.PropTypes.number,
  relative_current_experience: React.PropTypes.number,
}

const mapStateToProps = state => ({
  ...state.user,
})

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(LvlExpCredits)



// WEBPACK FOOTER //
// ./src/components/Main/Profile/LvlExpCredits/index.jsx